const carouselItems = [
  {
    title: '热播剧集',
    subtitle: '追剧不等待',
    desc: '最新人气剧集每日同步更新，从国产热播到海外精品，一站式追剧体验，告别缓冲烦恼。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20composition%20with%20soft%20red%20and%20gold%20tones%2C%20abstract%20film%20reel%20and%20streaming%20visual%20elements%2C%20elegant%20modern%20living%20room%20with%20large%20screen%20showing%20warm%20glow%2C%20cozy%20atmosphere%2C%20artistic%20minimalist%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '每日更新',
  },
  {
    title: '院线大片',
    subtitle: '高清抢先看',
    desc: '院线热门电影第一时间上线，4K超清画质配合影院级音效，足不出户享受大银幕体验。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20cinema%20theater%20atmosphere%20with%20warm%20amber%20lighting%2C%20abstract%20geometric%20shapes%20representing%20movie%20screens%2C%20elegant%20golden%20accents%2C%20soft%20bokeh%20background%2C%20modern%20minimalist%20design%2C%20cinematic%20mood&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '热门推荐',
  },
  {
    title: '经典重温',
    subtitle: '百看不厌',
    desc: '精心整理豆瓣高分经典影片，涵盖影史名作和口碑佳作，随时回顾那些打动心灵的故事。',
    img: 'https://readdy.ai/api/search-image?query=Vintage%20film%20aesthetic%20with%20warm%20sepia%20and%20gold%20tones%2C%20old%20movie%20camera%20silhouette%2C%20soft%20nostalgic%20lighting%2C%20abstract%20film%20strip%20elements%2C%20elegant%20minimalist%20composition%2C%20artistic%20photography%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '高分佳作',
  },
  {
    title: '动漫精选',
    subtitle: '二次元盛宴',
    desc: '热门新番与经典动漫一网打尽，国漫日漫全覆盖，高清画质还原每一个精彩打斗场面。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20anime%20inspired%20abstract%20composition%20with%20vibrant%20warm%20colors%2C%20flowing%20dynamic%20shapes%2C%20soft%20geometric%20patterns%2C%20modern%20illustration%20style%2C%20elegant%20golden%20and%20coral%20accents%2C%20dreamy%20atmosphere&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '新番热播',
  },
  {
    title: '综艺娱乐',
    subtitle: '欢乐时光',
    desc: '热门综艺节目全收录，搞笑、音乐、竞技、旅行各类综艺随心看，轻松解压每一天。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20warm%20stage%20lighting%20abstract%20composition%2C%20soft%20golden%20spotlights%2C%20artistic%20geometric%20shapes%2C%20entertainment%20show%20aesthetic%2C%20modern%20minimalist%20design%2C%20elegant%20warm%20color%20palette&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '轻松解压',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              焦点专题
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              精选热门影视专题，发现你感兴趣的好内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselItems.map((item, idx) => (
              <a
                key={idx}
                href="#index"
                className={`group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 ${
                  idx === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2' : ''
                }`}
              >
                <div className={`relative ${idx === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'} overflow-hidden`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading={idx > 3 ? 'lazy' : undefined}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-primary-600 font-medium mt-0.5">{item.subtitle}</p>
                  <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}